var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useStore } from 'react-context-hook';
import { useParams } from 'react-router-dom';
import { Row } from 'react-styled-flexboxgrid';
import { RoundLogo } from '@app/components/atm.logo/logo.component';
import { axiosClient } from '@app/configure-app';
import { ButtonAvaliar, CenterModal, } from '@app/modules/quiz/components/phase-completed/components/avaliation-modal/avaliation-modal.styled';
import { H1, H2 } from '@atomic';
export var Unsubscribe = function (_a) {
    var logo = _a.logo;
    var id = useParams().id;
    var _b = React.useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useStore('unsubscribe', false), _ = _c[0], setUnsubscribe = _c[1];
    React.useEffect(function () {
        console.log(id);
    }, []);
    var handleSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isLoading)
                        return [2 /*return*/];
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, axiosClient.post("usuario/" + id + "/unsubscribe")];
                case 2:
                    response = _a.sent();
                    console.log(response.data);
                    return [3 /*break*/, 4];
                case 3:
                    setIsLoading(false);
                    setUnsubscribe(true);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(CenterModal, null,
        React.createElement(RoundLogo, { src: logo }),
        React.createElement(H1, { style: { fontWeight: 'bold', fontSize: 22 } }, "Tem certeza que deseja cancelar a inscri\u00E7\u00E3o?"),
        React.createElement(H2, null, "Ao cancelar a inscri\u00E7\u00E3o voc\u00EA n\u00E3o receber\u00E1 mais as notifica\u00E7\u00F5es por email."),
        React.createElement(Row, { style: { justifyContent: 'center' } },
            React.createElement(ButtonAvaliar, { onClick: handleSubmit, disabled: isLoading }, isLoading ? 'Cancelando...' : 'Cancelar Inscrição'))));
};
